var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"category-tag",attrs:{"href":_vm.href},on:{"click":_vm.click}},[_vm._v(_vm._s(_vm.name)),(_vm.num)?[_vm._v("("+_vm._s(_vm.num)+")")]:_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }